import { Box, Stack, Typography } from "@mui/material";
import { type ReactNode } from "react";

type Props = {
  validatedAt?: string | null;
  /** How the row was resolved, already labelled; null while it is still open. */
  resolutionMethod?: string | null;
  /** Read-only: assignment lives on the linked notification submission. */
  staffAssigneeName?: string | null;
};

function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

/** Compact label-over-value pair for the metadata strip. */
function MetaField({ label, value }: { label: string; value: ReactNode }) {
  return (
    <Box>
      <Typography variant="caption" color="text.secondary" sx={{ display: "block" }}>
        {label}
      </Typography>
      <Typography variant="body2" component="div">
        {value}
      </Typography>
    </Box>
  );
}

/** Review and ownership metadata under the drawer's status chips. */
export function ExceedanceMetaLine({ validatedAt, resolutionMethod, staffAssigneeName }: Props) {
  if (!validatedAt && !resolutionMethod && !staffAssigneeName) return null;
  return (
    <Stack direction="row" spacing={3} flexWrap="wrap" useFlexGap>
      {validatedAt && <MetaField label="Validated" value={formatDate(validatedAt)} />}
      {resolutionMethod && <MetaField label="Resolution method" value={resolutionMethod} />}
      {staffAssigneeName && <MetaField label="Assignee" value={staffAssigneeName} />}
    </Stack>
  );
}
